
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    question: '¿Cuánto tarda una instalación de pladur?',
    answer: 'Depende del proyecto, pero un tabique estándar se puede instalar en 1-2 días. Un falso techo de una habitación suele tardar 1 día. Te daremos plazos exactos en el presupuesto.',
  },
  {
    question: '¿Qué incluye el precio de instalación?',
    answer: 'Incluye materiales (placas, perfilería, tornillería), mano de obra, transporte y limpieza final. El acabado queda listo para pintar.',
  },
  {
    question: '¿El pladur aísla del ruido?',
    answer: 'Sí, especialmente con lana de roca o fibra de vidrio en el interior. Es ideal para mejorar el aislamiento acústico entre habitaciones o con vecinos.',
  },
  {
    question: '¿Se puede instalar pladur en baños?',
    answer: 'Sí, utilizamos placas de pladur antihumedad (color verde) especialmente diseñadas para zonas húmedas como baños, cocinas y lavaderos.',
  },
  {
    question: '¿Trabajáis con la vivienda ocupada?',
    answer: 'Sí, coordinamos horarios y trabajamos con limpieza y orden para minimizar molestias. Protegemos muebles y suelos durante la obra.',
  },
];

const MiniFAQSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section ref={ref} className="py-24 bg-dark-card">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="inline-block px-4 py-2 bg-orange-primary/10 border border-orange-primary rounded-full mb-6"
          >
            <span className="text-orange-primary text-sm font-bold">Preguntas frecuentes</span>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-4xl md:text-5xl font-extrabold text-text-primary mb-6"
          >
            Resolvemos tus dudas
          </motion.h2>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 * index }}
              className="bg-dark-bg border border-dark-border rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-dark-card/50 transition-colors duration-300"
              >
                <span className="text-text-primary font-bold text-lg pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-orange-primary text-2xl transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <motion.div
                initial={false}
                animate={{
                  height: openIndex === index ? 'auto' : 0,
                  opacity: openIndex === index ? 1 : 0,
                }}
                transition={{ duration: 0.3 }}
                className="overflow-hidden"
              >
                <div className="px-8 pb-6">
                  <p className="text-text-secondary leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>

        {/* Link to Full FAQ */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-center mt-12"
        >
          <Link
            to="/faq"
            className="inline-flex items-center space-x-2 text-orange-primary hover:text-orange-secondary transition-colors duration-300 font-medium"
          >
            <span>Ver todas las preguntas frecuentes</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default MiniFAQSection;
